/**
 * @param itemType {string} Item type
 * @param referencedId {string} Referenced item id
 * @returns {string} Item id
 */
import {cartConstants} from './index';


export const itemId = (itemType, referencedId) => {

    return itemType + '-' + referencedId;
};


/**
 * @param data {object} Data to get
 * @returns {string} Item id
 */
export const itemIdFromData = data => {

    // if the data already contains it
    if (data.itemId) {

        return data.itemId;
    }

    const {itemType} = data;
    let referencedId;

    switch (itemType) {

        case cartConstants.CART_ITEM_TYPE_CONTENT:

            referencedId = data.contentId;
            break;

        default:

            throw Error(`Unable to build item id for type: ${itemType}`);

    }

    if (!referencedId) {

        throw Error(`Empty referenceId for type: ${itemType}`);
    }

    return itemId(itemType, referencedId);
};
